import { FieldErrors, useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { BefehlFormField } from '../Generic'
import AuftragCheckbox from '../Generic/AuftragCheckbox'
import { useEffect, useMemo } from 'react'
import { Befehl9FormData } from './schema'

export interface Auftrag9_67_68FormProps {
  readOnly: boolean
  'data-testid': string
  activateEmptyFieldWarnings: boolean
  errors?: FieldErrors
}

export default function Auftrag9_67_68Form({
  readOnly,
  'data-testid': testId,
  activateEmptyFieldWarnings,
  errors
}: Readonly<Auftrag9_67_68FormProps>) {
  const { control, formState, watch, setValue } =
    useFormContext<Befehl9FormData>()
  const { t } = useTranslation('ui-befehle')

  const fieldErrors = useMemo(() => {
    return errors ?? formState.errors
  }, [errors, formState.errors])

  const auftrag_9_67_checkbox = watch('auftrag_9_67.enabled')
  const auftrag_9_68_checkbox = watch('auftrag_9_68.enabled')

  useEffect(() => {
    if (auftrag_9_67_checkbox) {
      setValue('auftrag_9_68.enabled', false)
    }
  }, [auftrag_9_67_checkbox, setValue])

  useEffect(() => {
    if (auftrag_9_68_checkbox) {
      setValue('auftrag_9_67.enabled', false)
    }
  }, [auftrag_9_68_checkbox, setValue])

  return (
    <div className="flex items-baseline">
      {/* Match BefehlFormAuftrag spacing structure */}
      <div className="w-1.75 shrink-0" />
      <div className="w-1.75 shrink-0 ml-0.5 mr-1" />

      <div className="flex-grow">
        <div className="flex flex-col sm:flex-row sm:items-baseline gap-1 sm:gap-2">
          <span data-testid={`${testId}-text`}>
            {t('auftraege.9_67/68.label')}
          </span>

          <div className="flex flex-row flex-wrap items-baseline gap-2 sm:gap-4 shrink-0">
            {(!readOnly || !auftrag_9_68_checkbox) && (
              <BefehlFormField
                name="auftrag_9_67.enabled"
                control={control}
                label=""
                readOnly={readOnly}
                activateEmptyWarning={activateEmptyFieldWarnings}
                data-testid={`${testId}-auftrag-9-67`}
                render={({ field }) => (
                  <div className="flex items-baseline gap-0.5">
                    <div className="flex justify-center items-start pt-0.25">
                      <AuftragCheckbox
                        checked={field.value}
                        label={`9.67`}
                        onChange={(e) => field.onChange(e.target.checked)}
                        readOnly={readOnly}
                        data-testid={`${testId}-auftrag-9-67-inner`}
                        errors={fieldErrors}
                      />
                    </div>
                    <span data-testid={`${testId}-text-ja`}>
                      {t('auftraege.9_67/68.ja')}
                    </span>
                  </div>
                )}
              />
            )}
            {(!readOnly ||
              (!auftrag_9_67_checkbox && !auftrag_9_68_checkbox)) && (
              <span data-testid={`${testId}-text-oder`}>
                {t('auftraege.9_67/68.oder')}
              </span>
            )}
            {(!readOnly || !auftrag_9_67_checkbox) && (
              <BefehlFormField
                name="auftrag_9_68.enabled"
                control={control}
                label=""
                readOnly={readOnly}
                activateEmptyWarning={activateEmptyFieldWarnings}
                data-testid={`${testId}-auftrag-9-68`}
                render={({ field }) => (
                  <div className="flex items-baseline gap-0.5">
                    <div className="flex justify-center items-start pt-0.25">
                      <AuftragCheckbox
                        checked={field.value}
                        label={`9.68`}
                        onChange={(e) => field.onChange(e.target.checked)}
                        readOnly={readOnly}
                        data-testid={`${testId}-auftrag-9-68-inner`}
                        errors={fieldErrors}
                      />
                    </div>
                    <span data-testid={`${testId}-text-nein`}>
                      {t('auftraege.9_67/68.nein')}
                    </span>
                  </div>
                )}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
